import {Action} from '@ngrx/store';
import {PolledAirDatum, StartAirDataPollRequest} from '../models/air-data';

export enum AirDataPollActionTypes {
  StartAirDataPoll = '[AirDataPoll] Start Air Data Poll',
  UpsertPolledAirData = '[AirDataPoll] Upsert Polled Air Data',
  StopAirDataPoll = '[AirDataPoll] Stop Air Data Poll'
}

export class StartAirDataPoll implements Action {
  readonly type = AirDataPollActionTypes.StartAirDataPoll;

  constructor(public payload: StartAirDataPollRequest) {
  }
}

export class UpsertPolledAirData implements Action {
  readonly type = AirDataPollActionTypes.UpsertPolledAirData;

  constructor(public payload: PolledAirDatum[]) {
  }
}

export class StopAirDataPoll implements Action {
  readonly type = AirDataPollActionTypes.StopAirDataPoll;
}

export type AirDataPollActions =
  | StartAirDataPoll
  | UpsertPolledAirData
  | StopAirDataPoll;
